window.AS = window.AS || {};

window.AS.config = window.AS.config || {
  localStoragePrefix: "o_",
  requestDataFormat: "kv", /*                                            */
  loadQueueDelay: 200,
  asyncQueueInterval: 400,
  asyncQueueTimeout: 4000,
  beaconBaseUrl: "/error-logging/",
  beacons: {
    performance: "ottoperformance.gif",
    javascript: "ottojs.gif",
    custom: "ottocustom.gif",
  },
  comScoreUrl: "",
};



window.AS = window.AS || {};

window.o_scale = window.o_scale || {};

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
window.AS.RUM = (function (w, d, config) {
  "use strict";

  /*                                             */
  const dataContainer = {};
  /*                                            */
  const taskQueue = [];
  /*                 */
  const mousemoveStartTimestamp = 0;
  const EMERGENCY_RUM_TOGGLE = "EMR_RUM";

  /*                  */
  const storage = new o_global.Storage(function () {
    return window.localStorage;
  });

  /**
 *
 *
 *
 *
 *
 *
 */
  function sortArrayOfObjects(property) {
    let sortOrder = 1;
    let key = property;

    if (key[0] === "-") {
      sortOrder = -1;
      key = key.substr(1);
    }

    return function (a, b) {
      const result = a[key] < b[key] ? -1 : a[key] > b[key] ? 1 : 0;

      return result * sortOrder;
    };
  }

  /**
 *
 *
 *
 */
  function isLocalStorageAvailable() {
    return !!storage.isAvailable;
  }

  /**
 *
 *
 *
 *
 *
 */
  function isPerformanceFeatureAvailable(feature) {
    const perf =
      w.performance ||
      w.mozPerformance ||
      w.webkitPerformance ||
      w.msPerformance;
    let result;

    if (perf) {
      result = window.performance[feature];
    }

    return !!result;
  }

  /**
 *
 *
 *
 *
 *
 *
 */
  function allPropsTrue(obj) {
    let i;

    for (i in obj) {
      if (obj.hasOwnProperty(i) && !obj[i]) {
        return false;
      }
    }

    return true;
  }

  /**
 *
 *
 *
 *
 *
 *
 *
 *
 */
  function extendNamespace(namespace, namespaceString) {
    let parts = namespaceString ? namespaceString.split(".") : [];
    let parent = namespace || "";
    let pl;
    let i;

    if (!!namespace && !!namespaceString) {
      /*                      */
      if (parts[0] === "window") {
        parts = parts.slice(1);
      }

      pl = parts.length;

      for (i = 0; i < pl; i += 1) {
        /*                      */
        if (typeof parent[parts[i]] === "undefined") {
          parent[parts[i]] = {};
        }

        parent = parent[parts[i]];
      }

      return parent;
    }

    return false;
  }

  /**
 *
 *
 *
 *
 *
 *
 *
 *
 */
  function sendImageBeacon(timing, group, params, ongoing) {
    const sendPermanently = typeof ongoing === "boolean" ? ongoing : false;
    /*                                   */
    let dataContainerRef;
    /*                 */
    let beaconUrl;
    /*                           */
    let beacon;

    /*                                                         */
    if (
      !o_util.toggle.get(EMERGENCY_RUM_TOGGLE, true) ||
      o_util.misc.isPreview(w.location.href)
    ) {
      return false;
    }

    if (
      window.location.hostname.indexOf("localhost") === -1 &&
      window.location.hostname.indexOf("otto.de") === -1
    ) {
      /*                                                                                                                          */
      return false;
    }

    if (
      !!timing &&
      !!group &&
      !!config.beacons[group] &&
      typeof params === "object"
    ) {
      if (!dataContainer[timing]) {
        dataContainer[timing] = {};
      }

      if (!dataContainer[timing][group]) {
        dataContainer[timing][group] = {};
      }

      dataContainerRef = dataContainer[timing][group];
      if (!dataContainerRef.send) {
        dataContainerRef.send = false;
      }

      beacon = d.createElement("img");
      /*                      */
      beacon.onload = function () {
        dataContainerRef.send = !sendPermanently;
      };
      /*                      */
      beacon.onerror = function () {
        /*                  */
      };

      if (dataContainerRef.send !== true && Object.keys(params).length > 0) {
        if (group === "performance") {
          try {
            window.o_scale.rum.sendData(params);
          } catch (e) {
            /*                                                   */
          }
        } else {
          beaconUrl = config.beaconBaseUrl + config.beacons[group];

          switch (config.requestDataFormat) {
            case "kv":
              if (group === "javascript" || group === "custom") {
                /*                                                        */
                /*                                              */
                beacon.src = `${beaconUrl}?${o_util.core
                  .serialize(params)
                  .replace(/\+/g, "%20")}`;
              } else {
                beacon.src = `${beaconUrl}?${o_util.core.serialize(params)}`;
              }
              break;
            case "json":
              beacon.src = `${beaconUrl}?data=${encodeURIComponent(
                JSON.stringify(params)
              )}`;
              break;
            default:
              break;
          }
        }

        return true;
      }
      dataContainerRef.send = true;

      return false;
    }

    return false;
  }

  /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
  function addToTaskQueue(beacon, timing, task, priority, async) {
    const type = async || false;
    const order = priority || 0;

    if (!!beacon && !!config.beacons[beacon] && !!timing && !!task) {
      taskQueue.push({
        beacon,
        timing,
        task,
        order,
        async: type,
      });

      return true;
    }

    return false;
  }

  /**
 *
 *
 *
 *
 *
 *
 *
 */
  function removeFromTaskQueue(beacon, timing, task) {
    let ret;

    if (!!beacon && !!timing && !!task) {
      taskQueue.forEach(function (el, i) {
        if (el.beacon === beacon && el.timing === timing && el.task === task) {
          taskQueue.splice(i, 1);
          ret = true;
        } else {
          ret = false;
        }
      });
    } else {
      ret = false;
    }

    return ret;
  }

  /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
  function getTaskQueue(beacon, timing) {
    const taskList = [];
    let item;

    taskQueue.sort(sortArrayOfObjects("order"));

    /*                      */
    if (!!beacon && beacon in config.beacons && !!timing) {
      for (item in taskQueue) {
        /*                      */
        if (taskQueue.hasOwnProperty(item)) {
          if (
            taskQueue[item].timing === timing &&
            taskQueue[item].beacon === beacon
          ) {
            taskList.push({
              task: taskQueue[item].task,
              async: taskQueue[item].async,
            });
          }
        }
      }
    }

    return taskList;
  }

  /**
 *
 *
 */
  function clearTaskQueue() {
    taskQueue.length = 0;
  }

  /**
 *
 *
 *
 *
 */
  function checkAsyncTasks() {
    const result = [];
    let counter = 0;
    let timing;
    let beacon;

    for (timing in dataContainer) {
      if (dataContainer.hasOwnProperty(timing)) {
        for (beacon in dataContainer[timing]) {
          if (dataContainer[timing].hasOwnProperty(beacon)) {
            if (dataContainer[timing][beacon].async) {
              if (
                !!allPropsTrue(dataContainer[timing][beacon].asyncTasks) &&
                dataContainer[timing][beacon].send === false
              ) {
                dataContainer[timing][beacon].done = true;
                result.push({
                  timing,
                  beacon,
                  params: dataContainer[timing][beacon].data,
                  send: dataContainer[timing][beacon].send,
                });
              } else {
                counter += 1;
              }
            }
          }
        }
      }
    }

    return result.length > 0 ? result : counter;
  }

  /**
 *
 *
 *
 *
 *
 *
 */
  function handleBeaconRequest(timing, beacon) {
    if (!!timing && !!beacon) {
      try {
        sendImageBeacon(
          timing,
          beacon,
          dataContainer[timing][beacon].data,
          false
        );
      } catch (e) {
        /*                                   */
      }
    }
  }

  /**
 *
 *
 *
 *
 *
 *
 *
 */
  function prepareDataContainer(type, beacon) {
    if (typeof dataContainer[type] === "undefined") {
      dataContainer[type] = {};
    }

    dataContainer[type][beacon] = {};
    dataContainer[type][beacon].data = {};
    dataContainer[type][beacon].asyncTasks = {};
    dataContainer[type][beacon].async = false;
    dataContainer[type][beacon].done = false;
    dataContainer[type][beacon].send = false;

    return dataContainer[type][beacon];
  }

  /**
 *
 *
 *
 *
 *
 *
 *
 */
  function handleTasks(timing, doRequest, parameter) {
    const params = parameter || [];
    const req = doRequest || true;
    let beacon;
    let data;
    let target;
    let tasks;

    if (timing) {
      for (beacon in config.beacons) {
        if (config.beacons.hasOwnProperty(beacon)) {
          tasks = getTaskQueue(beacon, timing);
          if (tasks.length > 0) {
            const beaconObj = prepareDataContainer(timing, beacon);

            /*                      */
            /*                       */
            tasks.forEach((el) => {
              if (el.async) {
                beaconObj.async = true;
                beaconObj.asyncTasks[el.task] = false;
                params.unshift(el.task, beaconObj);

                /*                                 */
                /*                       */
                extendNamespace(window, el.task).apply(null, params);
              } else {
                /*                                 */
                /*                       */
                data = extendNamespace(window, el.task).apply(null, params);
                target = beaconObj.data;
                o_util.core.extend(target, data, false, false);
              }
            });

            if (
              !!req &&
              beaconObj.async !== true &&
              beaconObj.data.empty !== true
            ) {
              handleBeaconRequest(timing, beacon);
            }
          }
        }
      }
    }
  }

  /**
 *
 *
 *
 *
 *
 *
 *
 *
 */
  function getPagecluster() {
    const data = {
      pagecluster: -2,
    };
    /*                 */
    const dataPageCluster = o_util.misc.getPagecluster();

    if (dataPageCluster) {
      data.pagecluster = dataPageCluster;
    } else if (dataPageCluster === "") {
      data.pagecluster = -1;
    }

    return data;
  }

  /**
 *
 *
 *
 *
 */
  function cheers() {
    /*              */
    o_global.eventLoader.onReady(0, function () {
      handleTasks("ready", true, []);
    });

    /*                                                             */
    o_global.eventLoader.onLoad(0, function () {
      o_global.eventLoader.onAllScriptsExecuted(0, function () {
        setTimeout(function () {
          handleTasks("load", true, []);
        }, config.loadQueueDelay);

        const timer = setInterval(function () {
          const check = checkAsyncTasks();
          let i;

          if (check) {
            for (i in check) {
              if (check.hasOwnProperty(i) && check[i].send !== true) {
                handleBeaconRequest(check[i].timing, check[i].beacon);
              }
            }
          } else {
            clearInterval(timer);
          }
        }, config.asyncQueueInterval);

        setTimeout(function () {
          clearInterval(timer);
        }, config.asyncQueueTimeout);
      });
    });

    /*              */
    w.addEventListener("error", function (event) {
      handleTasks("error", true, [
        event.message,
        event.filename,
        event.lineno,
        event.colno,
        event.error,
      ]);
    });

    /*                                                                                   */
    w.addEventListener("unhandledrejection", function (event) {
      handleTasks("error", true, [
        event.reason && event.reason.message
          ? event.reason.message
          : "No reason given (empty promise rejection).",
        undefined,
        undefined,
        undefined,
        event.reason,
      ]);
    });
  }

  /*                               */
  const localStorageAvailable = isLocalStorageAvailable();
  const navigationTimingAvailable = isPerformanceFeatureAvailable("timing");
  const resourceTimingAvailable = isPerformanceFeatureAvailable("getEntries");

  return {

    storage,
    taskQueue,
    dataContainer,
    localStorageAvailable,
    navigationTimingAvailable,
    resourceTimingAvailable,
    sendImageBeacon,
    getPagecluster,
    addToTaskQueue,
    cheers,
  };
})(window, document, window.AS.config);

/*                     */
window.AS.RUM.cheers();


/**
 *
 *
 *
 *
 *
 */
window.AS.RUM = (function (w, d, RUM) {
  "use strict";

  const timing = RUM.navigationTimingAvailable ? w.performance.timing : false;
  const perf = w.performance;
  const xhr = w.XMLHttpRequest;
  const storage = new o_global.Storage(function () {
    return window.localStorage;
  });

  /*                                                                     */
  const perfDataDetailed = [
    {
      name: "networkTime",
      minuend: "responseEnd",
      subtrahend: "navigationStart",
    },
    {
      name: "domContentLoadedStart",
      minuend: "domContentLoadedEventStart",
      subtrahend: "navigationStart",
    },
    {
      name: "domContentLoaded",
      minuend: "domContentLoadedEventEnd",
      subtrahend: "navigationStart",
    },
    {
      name: "domTime",
      minuend: "domComplete",
      subtrahend: "domLoading",
    },
    {
      name: "dnsTime",
      minuend: "domainLookupEnd",
      subtrahend: "domainLookupStart",
    },
  ];

  const perfDataImportant = [
    {
      name: "timeToFirstByte",
      minuend: "responseStart",
      subtrahend: "navigationStart",
    },
    {
      name: "rum_complete",
      minuend: "loadEventEnd",
      subtrahend: "navigationStart",
    },
    {
      name: "rum_domComplete",
      minuend: "domComplete",
      subtrahend: "navigationStart",
    },
    {
      name: "sslHandshakeTime",
      minuend: "connectEnd",
      subtrahend: "secureConnectionStart",
    },
  ];

  const staticBrowserDataDetailed = [
    {
      name: "htmlLength",
      value: d.body.innerHTML.length,
    },
  ];

  const staticBrowserDataBasic = [
    {
      name: "parentUrl",
      value: w.location.href,
    },
    {
      name: "referrer", /*                                                    */
      value: d.referrer.substring(0, 256),
    },
  ];

  function _addPerfData(config) {
    const data = {};

    config.forEach(function (el) {
      const min = el.minuend;
      const sub = el.subtrahend;
      let val;

      data[el.name] = -2;

      if (timing) {
        val =
          !!timing[min] && !!timing[sub] && timing[min] - timing[sub] >= 0
            ? timing[min] - timing[sub]
            : -1;
        data[el.name] = val;
      }
    });

    return data;
  }

  function _getStaticBrowserData(staticBrowserData) {
    const data = {};

    staticBrowserData.forEach(function (el) {
      data[el.name] = el.value ? el.value : -1;
    });

    return data;
  }

  /**
 *
 *
 *
 *
 *
 *
 *
 */
  function getPerfData() {
    return _addPerfData(perfDataDetailed.concat(perfDataImportant));
  }

  /**
 *
 *
 *
 *
 *
 *
 *
 */
  function getPerfDataDetailed() {
    return _addPerfData(perfDataDetailed);
  }

  /**
 *
 *
 *
 *
 *
 *
 *
 */
  function getPerfDataImportant() {
    return _addPerfData(perfDataImportant);
  }

  /**
 *
 *
 *
 *
 */
  function getStaticBrowserData() {
    return _getStaticBrowserData(
      staticBrowserDataBasic.concat(staticBrowserDataDetailed)
    );
  }

  /**
 *
 *
 *
 *
 */
  function getStaticBrowserDataBasic() {
    return _getStaticBrowserData(staticBrowserDataBasic);
  }

  /**
 *
 *
 *
 *
 */
  function getStaticBrowserDataDetailed() {
    return _getStaticBrowserData(staticBrowserDataDetailed);
  }

  /**
 *
 *
 *
 */
  function getUniqueIds() {
    const data = {
      vid: -2,
      bid: -2,
    };

    data.vid = o_util.cookie.get("visitorId")
      ? o_util.cookie.get("visitorId")
      : -1;
    data.bid = o_util.cookie.get("BrowserId")
      ? o_util.cookie.get("BrowserId")
      : -1;

    return data;
  }

  /**
 *
 *
 *
 */
  function isFirstView() {
    const ref = document.referrer;
    const data = {
      firstView: -2,
    };

    data.firstView = !(!!ref && ref.indexOf("www.otto.de") > -1);

    return data;
  }

  /**
 *
 *
 *
 *
 */
  function isApp() {
    return {
      app: o_global.helper.cookieExist("app"),
    };
  }

  /**
 *
 *
 *
 *
 */
  function getBreakpoint() {
    const data = {
      bp: -2,
    };

    if (
      !!o_global &&
      !!o_global.device &&
      !!o_global.device.breakpoint &&
      typeof o_global.device.breakpoint.getCurrentBreakpoint === "function"
    ) {
      data.bp = o_global.device.breakpoint.getCurrentBreakpoint();
    }

    return data;
  }

  /**
 *
 *
 *
 *
 */
  function _initNativeProxy() {
    /*                                     */
    xhr.prototype.open = _openProxy(xhr.prototype.open);
  }

  /**
 *
 *
 *
 *
 *
 *
 *
 */
  function _openProxy(initialFunction) {
    return function (type, url) {
      /*                           */
      if (url.indexOf("/ts-rcv/") !== -1) {
        /*                   */
        this.send = _sendProxy(this.send, url);
      }

      /*                         */
      return initialFunction
        ? initialFunction.apply(this, [].slice.call(arguments))
        : null;
    };
  }

  /**
 *
 *
 *
 *
 *
 *
 *
 *
 */
  function _sendProxy(initialFunction, url) {
    return function () {
      /*                                 */
      this.onreadystatechange = _onReadyStateChangeProxy(
        this,
        url,
        this.onreadystatechange
      );

      /*                         */
      return initialFunction
        ? initialFunction.apply(this, [].slice.call(arguments))
        : null;
    };
  }

  /**
 *
 *
 *
 *
 *
 *
 *
 *
 */
  function _onReadyStateChangeProxy(currentXhr, url, initialFunction) {
    return function () {
      /*              */
      if (currentXhr.readyState === 4) {
        /*                                     */
        setTimeout(function () {
          /*         */
          _analyseRequest(url);
        }, 1);
      }

      /*                                       */
      return initialFunction
        ? initialFunction.apply(this, [].slice.call(arguments))
        : null;
    };
  }

  /**
 *
 *
 *
 *
 *
 *
 */
  function _analyseRequest(url) {
    let entries;
    let entry;

    /*                           */
    if (url.indexOf("/ts-rcv/") === -1) {
      return false;
    }

    /*                                                      */
    entries = perf.getEntriesByName(
      `${document.location.protocol}/*                              */
    );

    /*           */
    if (!entries.length) {
      /*                                */
      entries = perf.getEntriesByName(url);
    }

    /*       */
    if (entries.length) {
      /*                                                                */
      entry = entries.pop();

      /*           */
      _storeRequestMetrics(entry);
    }

    return undefined;
  }

  /**
 *
 *
 *
 *
 *
 *
 */
  function _storeRequestMetrics(entry) {
    const rtt = Math.min(entry.duration, 10000); /*          */
    const negativeRttErrorCode = -1;

    if (rtt < 0) {
      storage.setItem("rum_srttErrorCode", negativeRttErrorCode);
    } else {
      _storeRttValues(Math.round(entry.duration)); /*                                   */
      _storeRttCount();
      _storeSrtt(rtt);
      _storeRttVar(rtt);
    }
  }

  /**
 *
 *
 *
 *
 *
 *
 */
  function _storeRttValues(rtt) {
    let rum_rttValues = storage.getItem("rum_rttValues"); /*          */

    /*                               */
    rum_rttValues = rum_rttValues ? rum_rttValues.split("|") : [];

    /*               */
    rum_rttValues.push(Math.round(rtt));

    /*                       */
    storage.setItem("rum_rttValues", rum_rttValues.slice(-20).join("|"));
  }

  /**
 *
 *
 *
 *
 */
  function _storeRttCount() {
    let rum_rttCount = storage.getItem("rum_rttCount"); /*                */

    /*                         */
    rum_rttCount = rum_rttCount ? parseInt(rum_rttCount, 10) : 0;

    /*                                               */
    storage.setItem("rum_rttCount", (rum_rttCount + 1).toString());
  }

  /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
  function _computeSrtt(rtt, srtt) {
    return !srtt ? rtt : srtt + 0.125 * (rtt - srtt);
  }

  /**
 *
 *
 *
 *
 *
 *
 */
  function _storeSrtt(rtt) {
    storage.setItem(
      "rum_srtt",
      _computeSrtt(rtt, parseFloat(storage.getItem("rum_srtt"))).toString()
    );
  }

  /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
  function _computeRttVar(rtt, lastRttVar, srtt) {
    return !lastRttVar
      ? rtt * 0.5
      : lastRttVar + 0.25 * (Math.abs(srtt - rtt) - lastRttVar);
  }

  /**
 *
 *
 *
 *
 *
 *
 */
  function _storeRttVar(rtt) {
    const currentRttVar = parseFloat(storage.getItem("rum_rttVar"));
    const srtt = parseFloat(storage.getItem("rum_srtt"));

    storage.setItem(
      "rum_rttVar",
      _computeRttVar(rtt, currentRttVar, srtt).toString()
    );
  }

  /**
 *
 *
 *
 *
 */
  function trackAjaxPerformance() {
    if (
      !xhr ||
      !perf ||
      typeof perf.getEntriesByName !== "function" ||
      !storage.isAvailable
    ) {
      return false;
    }

    /*           */
    return _initNativeProxy();
  }

  /**
 *
 */
  function trackResourceCount() {
    const data = {
      resourceCount: -2,
    };

    if (perf && typeof perf.getEntriesByType === "function") {
      data.resourceCount = perf
        .getEntriesByType("resource")
        .filter(function (r) {
          return (
            ["link", "script"].indexOf(r.initiatorType) !== -1 &&
            r.name.indexOf("otto.de/") !== -1
          );
        }).length;
    }

    return data;
  }

  /**
 *
 */
  function trackTimeToFirstPaint() {
    const data = {
      timeToFirstPaint: -2,
    };
    let firstPaintTime;

    if ("chrome" in w && typeof w.chrome.loadTimes === "function") {
      /*                                  */
      /*                         */
      const loadTimes = w.chrome.loadTimes();

      /*                                                      */
      if (loadTimes && loadTimes.firstPaintTime > 0) {
        firstPaintTime = loadTimes.firstPaintTime - loadTimes.startLoadTime;
      }

      /*                                                                                         */
      /*                                     */
      if (firstPaintTime > 0 && firstPaintTime < 3600) {
        data.timeToFirstPaint = Math.round(firstPaintTime * 1000);
      }
    } else if (timing) {
      if (timing.navigationStart !== 0) {
        /*                                                    */
        if (typeof timing.msFirstPaint === "number") {
          firstPaintTime = timing.msFirstPaint - timing.navigationStart;
        }

        if (typeof firstPaintTime === "number" && firstPaintTime > 0) {
          data.timeToFirstPaint = firstPaintTime;
        }
      }
    }

    return data;
  }

  /**
 *
 */
  function trackInlineScripts() {
    return {
      inlineScripts: document.querySelectorAll(
        "body script[type='text/javascript']:not([src]), body script:not([type]):not([src])"
      ).length,
    };
  }

  /**
 *
 */
  function supportsLinkPreload() {
    const link = document.createElement("link");

    return {
      supportsLinkPreload:
        !!link.relList &&
        !!link.relList.supports &&
        link.relList.supports("preload"),
    };
  }

  /**
 *
 *
 *
 */
  function collectAjaxPerformance() {
    const entryErrorCode = -3;
    const notAvailableErrorCode = -2;
    const data = {
      rum_srtt: entryErrorCode,
      rum_rttVar: entryErrorCode,
      rum_rttCount: entryErrorCode,
      rum_rttValues: entryErrorCode,
    };
    let rum_srtt;
    let rum_rttVar;
    let rum_rttCount;
    let rum_rttValues;
    let rum_srttErrorCode;

    if (storage.isAvailable) {
      /*              */
      rum_srtt = storage.getItem("rum_srtt");
      rum_rttVar = storage.getItem("rum_rttVar");
      rum_rttCount = storage.getItem("rum_rttCount");
      rum_rttValues = storage.getItem("rum_rttValues");

      if (!rum_srtt) {
        rum_srttErrorCode = storage.getItem("rum_srttErrorCode");
        data.rum_srttErrorCode = rum_srttErrorCode || entryErrorCode;

        /*            */
        storage.removeItem("rum_srttErrorCode");
      } else {
        /*                         */
        data.rum_srtt = rum_srtt;
        data.rum_rttVar = Math.round(rum_rttVar);
        data.rum_rttCount = rum_rttCount;
        data.rum_rttValues = rum_rttValues;

        /*                                   */
        storage.removeItem("rum_rttCount");
        storage.removeItem("rum_rttValues");
      }
    }

    if (
      !storage.isAvailable ||
      !RUM.navigationTimingAvailable ||
      !RUM.resourceTimingAvailable
    ) {
      data.rum_srttErrorCode = notAvailableErrorCode;
    }

    return data;
  }

  /*                                                      */

  function _init() {
    if (o_util.toggle.get("RUM_BasicInformation", true)) {
      RUM.addToTaskQueue(
        "performance",
        "load",
        "AS.RUM.getStaticBrowserDataBasic",
        0,
        false
      );
      RUM.addToTaskQueue("performance", "load", "AS.RUM.isApp", 0, false);
      RUM.addToTaskQueue(
        "performance",
        "load",
        "AS.RUM.getUniqueIds",
        0,
        false
      );
    }

    if (o_util.toggle.get("RUM_DetailedPerformance", false)) {
      RUM.addToTaskQueue(
        "performance",
        "load",
        "AS.RUM.getStaticBrowserDataDetailed",
        0,
        false
      );
      RUM.addToTaskQueue("performance", "load", "AS.RUM.isFirstView", 0, false);
      RUM.addToTaskQueue(
        "performance",
        "load",
        "AS.RUM.getPerfDataDetailed",
        0,
        false
      );
    }

    if (o_util.toggle.get("RUM_ImportantPerformance", true)) {
      RUM.addToTaskQueue(
        "performance",
        "load",
        "AS.RUM.getPerfDataImportant",
        0,
        false
      );
    }

    if (o_util.toggle.get("RUM_RoundTripTime", true)) {
      RUM.addToTaskQueue(
        "performance",
        "ready",
        "AS.RUM.trackAjaxPerformance",
        0,
        false
      );
      RUM.addToTaskQueue(
        "performance",
        "load",
        "AS.RUM.collectAjaxPerformance",
        0,
        false
      );
    }

    if (o_util.toggle.get("RUM_AssetX", true)) {
      RUM.addToTaskQueue(
        "performance",
        "load",
        "AS.RUM.trackResourceCount",
        0,
        false
      );
      RUM.addToTaskQueue(
        "performance",
        "load",
        "AS.RUM.trackTimeToFirstPaint",
        0,
        false
      );
      RUM.addToTaskQueue(
        "performance",
        "load",
        "AS.RUM.trackInlineScripts",
        0,
        false
      );
      RUM.addToTaskQueue(
        "performance",
        "load",
        "AS.RUM.supportsLinkPreload",
        0,
        false
      );
    }
  }

  _init();

  return o_util.core.extend(
    RUM,
    {

      getPerfData,
      getPerfDataImportant,
      getPerfDataDetailed,
      getStaticBrowserData,
      getStaticBrowserDataDetailed,
      getStaticBrowserDataBasic,
      getUniqueIds,
      isFirstView,
      isApp,
      getBreakpoint,
      trackAjaxPerformance,
      collectAjaxPerformance,
      trackResourceCount,
      trackTimeToFirstPaint,
      trackInlineScripts,
      supportsLinkPreload,
    },
    true,
    true
  );
})(window, document, window.AS.RUM || {});


/**
 *
 *
 *
 *
 *
 *
 */
window.AS.RUM = (function (w, d, RUM) {
  "use strict";

  const visibilityData = {
    wasHidden: false,
    pageVisibility: false,
    visibilityChanges: 0,
    hiddenTime: 0,
    visibleLoadTime: 0,
    customerWaitTime: 0,
  };
  /*           */
  let hiddenTimer;
  let visibleTimer;
  let customerWaitTimer;

  /**
 *
 *
 *
 */
  function getVisibilityData() {
    return visibilityData;
  }

  /**
 *
 *
 */
  function finishVisibilityDataCollection() {
    let eventName;

    /*                                                    */
    const visibilityProp = _getHiddenProp();

    /*                                                                         */
    if (!!visibilityProp) {
      eventName = `${visibilityProp.replace(/[H|h]idden/, "")}visibilitychange`;
      d.removeEventListener(eventName, visibilityChange, false);
    }

    /*          */
    _updateHiddenTime();
    _updateVisibleLoadTime();
    _updateCustomerWaitTime();

    /*                                  */
    if (
      !!document.visibilityState &&
      document.visibilityState === "prerender"
    ) {
      visibilityData.pageVisibility = "prerender";
    } else if (!visibilityData.wasHidden) {
      visibilityData.pageVisibility = "always_visible";
    } else if (visibilityData.hiddenTime > visibilityData.visibleLoadTime) {
      visibilityData.pageVisibility = "hidden";
    } else {
      visibilityData.pageVisibility = "intermittent_visible";
    }
  }

  /**
 *
 *
 *
 *
 */
  function _startVisibleTimer() {
    visibleTimer = new Date().getTime();
  }

  /**
 *
 *
 *
 *
 */
  function _updateVisibleLoadTime() {
    if (!!visibleTimer) {
      visibilityData.visibleLoadTime += new Date().getTime() - visibleTimer;
      visibleTimer = false;
    }
  }

  /**
 *
 *
 *
 *
 */
  function _startHiddenTimer() {
    hiddenTimer = new Date().getTime();
  }

  /**
 *
 *
 *
 *
 */
  function _updateHiddenTime() {
    if (!!hiddenTimer) {
      visibilityData.hiddenTime += new Date().getTime() - hiddenTimer;
      hiddenTimer = false;
    }
  }

  /**
 *
 *
 *
 *
 */
  function _startCustomerWaitTimer() {
    customerWaitTimer = new Date().getTime();
  }

  /**
 *
 *
 *
 *
 */
  function _updateCustomerWaitTime() {
    if (!!customerWaitTimer) {
      visibilityData.customerWaitTime +=
        new Date().getTime() - customerWaitTimer;
      customerWaitTimer = false;
    }
  }

  /**
 *
 *
 *
 *
 */
  function _getHiddenProp() {
    const p = ["webkit", "moz", "ms", "o"];
    let i;

    /*                                                  */
    if ("hidden" in d) {
      return "hidden";
    }

    /*                                                                */
    for (i = 0; i < p.length; i += 1) {
      if (`${p[i]}Hidden` in d) {
        return `${p[i]}Hidden`;
      }
    }

    /*                            */
    return null;
  }

  /**
 *
 *
 *
 *
 */
  function _isHidden() {
    const prop = _getHiddenProp();

    return !!prop ? d[prop] : false;
  }

  /**
 *
 *
 */
  function visibilityChange() {
    if (_isHidden()) {
      visibilityData.wasHidden = true;
      _updateVisibleLoadTime();
      _startHiddenTimer();
    } else {
      _updateHiddenTime();
      _startVisibleTimer();
    }

    /*                                     */
    _updateCustomerWaitTime();

    /*                           */
    visibilityData.visibilityChanges += 1;

    /*                                                                */
    if (
      !!document.visibilityState &&
      document.visibilityState === "prerender"
    ) {
      visibilityData.pageVisibility = "prerender";
    }
  }

  /**
 *
 *
 *
 *
 *
 */
  function _addVisibilityChangeListener() {
    let eventName;

    /*                                                    */
    const visibilityProp = _getHiddenProp();

    /*                                                                         */
    if (!!visibilityProp) {
      eventName = `${visibilityProp.replace(/[H|h]idden/, "")}visibilitychange`;
      d.addEventListener(eventName, visibilityChange, false);
    }
  }

  /**
 *
 *
 *
 *
 */
  function _init() {
    /*                                                                */
    if (
      !!document.visibilityState &&
      document.visibilityState === "prerender"
    ) {
      visibilityData.pageVisibility = "prerender";
    }
    /*                                          */
    else if (_isHidden()) {
      _startHiddenTimer();
      visibilityData.wasHidden = true;
      visibilityData.pageVisibility = "hidden";
    } else {
      _startVisibleTimer();
      visibilityData.pageVisibility = "always_visible";
    }

    /*                */
    _startCustomerWaitTimer();
  }

  /**
 *
 *
 *
 *
 */
  function _registerEvents() {
    /*           */
    _addVisibilityChangeListener();

    /*                  */
    o_global.eventLoader.onLoad(0, finishVisibilityDataCollection);
  }

  /* */
  _registerEvents();
  _init();

  return o_util.core.extend(
    RUM,
    {

      visibilityChange,
      finishVisibilityDataCollection,
      getVisibilityData,
    },
    true,
    true
  );
})(window, document, window.AS.RUM || {});


/**
 *
 *
 *
 *
 *
 */
window.AS.RUM = (function (w, d, RUM) {
  "use strict";

  /**
 *
 *
 *
 */
  function checkVisibilityData() {
    const visibilityData = window.AS.RUM.getVisibilityData();
    const data = {
      rum_wasHidden: -2,
      rum_pageVisibility: -2,
      rum_visibilityChanges: -2,
      rum_hiddenTime: -2,
      rum_visibleLoadTime: -2,
      rum_customerWaitTime: -2,
    };
    let key;

    /*                                                             */
    for (key in visibilityData) {
      if (visibilityData.hasOwnProperty(key)) {
        data[`rum_${key}`] = visibilityData[key];
      }
    }

    return data;
  }

  /*                                                     */
  function _init() {
    if (o_util.toggle.get("RUM_Visibility", false)) {
      RUM.addToTaskQueue(
        "performance",
        "load",
        "AS.RUM.checkVisibilityData",
        0,
        false
      );
    }
  }

  _init();

  return o_util.core.extend(
    RUM,
    {

      checkVisibilityData,
    },
    true,
    true
  );
})(window, document, window.AS.RUM || {});


window.AS.RUM =
  /**
 *
 *
 *
 *
 *
 */
  (function (w, d, RUM) {
    "use strict";

    /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
    function computeJsErrors(message, src, line, column, error) {
      /*                                            */
      const data = {
        jsErrors: -2,
        message: -2,
        src: -2,
        line: -2,
        column: -2,
        stack: -2,
      };
      let key;

      if (RUM.localStorageAvailable) {
        key = `${w.AS.config.localStoragePrefix}jsErrors`;

        if (localStorage[key]) {
          localStorage[key] = parseInt(localStorage[key], 10) + 1;
        } else {
          localStorage[key] = 1;
        }

        data.jsErrors = localStorage[key] ? localStorage[key] : -1;
      } else {
        data.jsErrors = -1;
      }

      if (typeof message === "object") {
        try {
          message = JSON.stringify(message);
        } catch (e) {
          /*                                            */
        }
      }

      data.message = message || -1;
      data.src = src || -1;
      data.line = line || -1;
      data.column = column || -1;
      data.pagecluster = RUM.getPagecluster().pagecluster;
      data.stack = !!error && error.stack ? error.stack.substring(0, 512) : -1;

      /*                                                                 */
      if (!window.AS.config.rumSendErrorsWithoutStack && data.stack === -1) {
        data.empty = true;
      }

      return data;
    }

    /*                                                        */
    function _init() {
      w.AS.config.rumJavascriptErrors = o_util.toggle.get("RUM_JavascriptErrors", true);
      w.AS.config.rumJavascriptErrorsPageCluster = o_util.toggle.get(
        `RUM_JavascriptErrors_${o_util.misc.getPagecluster()}`,
        true
      );
      w.AS.config.rumSendErrorsWithoutStack = o_util.toggle.get(
        "RUM_SendErrorsWithoutStack",
        false
      );

      if (w.AS.config.rumJavascriptErrors && w.AS.config.rumJavascriptErrorsPageCluster) {
        RUM.addToTaskQueue("javascript", "error", "AS.RUM.computeJsErrors", 0, false);
      }
    }

    _init();

    return o_util.core.extend(
      RUM,
      {

        computeJsErrors,
      },
      true,
      true
    );
  })(window, document, window.AS.RUM || {});


/**
 *
 *
 *
 *
 *
 *
 */
window.AS.RUM = (function (w, d, RUM) {
  "use strict";

  /*                                                    */
  function _init() {
    if (o_util.toggle.get("RUM_PageCluster", true)) {
      RUM.addToTaskQueue(
        "performance",
        "load",
        "AS.RUM.getPagecluster",
        0,
        false
      );
    }
  }

  _init();

  return o_util.core.extend(
    RUM,
    {
    },
    true,
    true
  );
})(window, document, window.AS.RUM || {});


/**
 *
 *
 *
 *
 *
 */
window.AS.RUM = (function (w, d, RUM) {
  "use strict";

  /**
 *
 *
 *
 *
 *
 *
 */
  function sendCustomRequest(namespace, data) {
    if (!o_util.toggle.get("RUM_CustomEvents", true)) {
      return false;
    }

    if (
      !!namespace &&
      typeof name === "string" &&
      namespace.length > 0 &&
      !!data &&
      typeof data === "object" &&
      Object.keys(data).length > 0
    ) {
      if (!o_util.toggle.get(`RUM_CustomEvents_${namespace.replace(/-/g, "_")}`, true)) {
        return false;
      }

      data.namespace = data.namespace ? data.namespace : namespace;
      data.timestamp = data.timestamp ? data.timestamp : new Date().getTime();
      data.pagecluster = RUM.getPagecluster().pagecluster;

      return RUM.sendImageBeacon("load", "custom", data, true);
    }

    return false;
  }

  return o_util.core.extend(
    RUM,
    {
      sendCustomRequest,
    },
    true,
    true
  );
})(window, document, window.AS.RUM || {});


/**
 *
 *
 *
 *
 *
 */
window.AS.RUM = (function (w, d, RUM) {
  "use strict";

  /**
 *
 *
 *
 */
  function getScreenDimensions() {
    const data = {
      rum_width: -2,
      rum_height: -2,
      rum_clientWidth: -2,
      rum_clientHeight: -2,
    };

    data.rum_width = w.screen.width ? w.screen.width : -1;
    data.rum_height = w.screen.height ? w.screen.height : -1;
    data.rum_clientWidth = d.documentElement.clientWidth
      ? d.documentElement.clientWidth
      : d.body.clientWidth
      ? d.body.clientWidth
      : -1;
    data.rum_clientHeight = d.documentElement.clientHeight
      ? d.documentElement.clientHeight
      : d.body.clientHeight
      ? d.body.clientHeight
      : -1;

    return data;
  }

  /**
 *
 *
 *
 */
  function getViewportDimensions() {
    const data = {
      rum_innerWidth: -2,
      rum_innerHeight: -2,
    };

    data.rum_innerWidth = w.innerWidth ? w.innerWidth : -1;
    data.rum_innerHeight = w.innerHeight ? w.innerHeight : -1;

    return data;
  }

  /**
 *
 *
 *
 */
  function getDevicePixelRatio() {
    const data = {
      rum_devicePixelRatio: -2,
    };

    data.rum_devicePixelRatio = w.devicePixelRatio ? w.devicePixelRatio : -1;

    return data;
  }

  /*                                                        */
  function _init() {
    if (o_util.toggle.get("RUM_ScreenSize", false)) {
      RUM.addToTaskQueue(
        "performance",
        "load",
        "AS.RUM.getScreenDimensions",
        0,
        false
      );
    }

    if (o_util.toggle.get("RUM_Viewport", true)) {
      RUM.addToTaskQueue(
        "performance",
        "load",
        "AS.RUM.getViewportDimensions",
        0,
        false
      );
    }

    if (o_util.toggle.get("RUM_DeviceInformation", true)) {
      RUM.addToTaskQueue(
        "performance",
        "load",
        "AS.RUM.getDevicePixelRatio",
        0,
        false
      );
    }
  }

  _init();

  return o_util.core.extend(
    RUM,
    {

      getScreenDimensions,
      getDevicePixelRatio,
      getViewportDimensions,
    },
    true,
    true
  );
})(window, document, window.AS.RUM || {});


/**
 *
 *
 *
 *
 *
 */
window.AS.RUM = (function (RUM, device) {
  "use strict";

  /**
 *
 *
 *
 *
 */
  function getDeviceData() {
    return {
      rum_deviceType: device.type,
      deviceOS: device.os,
      deviceBrowser: device.browser,
      rum_deviceOrientation: device.orientation.getCurrentOrientation(),
      rum_supportsTouch: device.isTouchable,
    };
  }

  /*                                                    */
  function _init() {
    if (o_util.toggle.get("RUM_DeviceInformation", true)) {
      RUM.addToTaskQueue(
        "performance",
        "load",
        "AS.RUM.getDeviceData",
        0,
        false
      );
    }
  }

  _init();

  return o_util.core.extend(
    RUM,
    {

      getDeviceData,
    },
    true,
    true
  );
})(window.AS.RUM || {}, o_global.device);


/**
 *
 *
 *
 *
 *
 */
window.AS.RUM = (function (w, d, RUM) {
  "use strict";

  /**
 *
 *
 *
 *
 *
 *
 */
  function getConnectionType() {
    const data = {
      rum_connectionType: -2,
    };
    let connection;

    if (typeof navigator !== "undefined") {
      connection =
        navigator.connection ||
        navigator.mozConnection ||
        navigator.webkitConnection;
      if (!!connection && typeof connection.type !== "undefined") {
        switch (parseInt(connection.type, 10)) {
          case 0:
            data.rum_connectionType = "unknown";
            break;
          case 1:
            data.rum_connectionType = "ethernet";
            break;
          case 2:
            data.rum_connectionType = "wifi";
            break;
          case 3:
            data.rum_connectionType = "cellular_2g";
            break;
          case 4:
            data.rum_connectionType = "cellular_3g";
            break;
          default:
            data.rum_connectionType = connection.type;
        }
      }
    }

    return data;
  }

  function getLoadingType() {
    return {
      loadingType: o_util.connection.getConnectionType(),
    };
  }

  /*                                                */
  function _init() {
    if (o_util.toggle.get("RUM_Connection", false)) {
      RUM.addToTaskQueue(
        "performance",
        "load",
        "AS.RUM.getConnectionType",
        0,
        false
      );
      RUM.addToTaskQueue(
        "performance",
        "load",
        "AS.RUM.getLoadingType",
        0,
        false
      );
    }
  }

  _init();

  return o_util.core.extend(
    RUM,
    {
      getConnectionType,
      getLoadingType,
    },
    true,
    true
  );
})(window, document, window.AS.RUM || {});


/*                   */

/**
 *
 *
 *
 *
 *
 */
window.AS.RUM = (function (w, d, RUM) {
  "use strict";

  /**
 *
 *
 *
 */
  function addMergeParameters() {
    let mergeParams = "";

    try {
      mergeParams = o_tracking.bct.getMergeParameters();
    } catch (e) {
      /*            */
    }

    return typeof mergeParams === "string"
      ? o_util.core.deserialize(mergeParams.replace("?", ""), false)
      : {};
  }

  /*                                               */
  function _init() {
    RUM.addToTaskQueue(
      "performance",
      "load",
      "AS.RUM.addMergeParameters",
      0,
      false
    );
  }

  _init();

  return o_util.core.extend(
    RUM,
    {
      addMergeParameters,
    },
    true,
    true
  );
})(window, document, window.AS.RUM || {});
